import { __assign, __rest } from "tslib";
import * as React from 'react';
export var DropdownField = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, children = _a.children, props = __rest(_a, ["label", "value", "onChange", "children"]);
    var change = React.useCallback(function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value); }, [onChange]);
    return (React.createElement("div", { className: "form-group" },
        React.createElement("div", { className: "form-control ".concat(value ? 'active' : '') },
            React.createElement("select", __assign({}, props, { value: value, onChange: change }), children)),
        label && React.createElement("label", { className: "text-floating" }, label)));
};
//# sourceMappingURL=index.js.map